<div class="row">
    <div class="col-xs-12 col-sm-12 col-md-8 p-0 m-0 Registration-split">
        <app-account-header [selectedHeader]="header" [tableCategory]="creditInvoice"></app-account-header>

        <div class="row">
            <div class="col-12 leftmargin">

                <h3 class="pdp-title">{{ "accountRegistration.contactsInformation.title" | cxTranslate }}</h3>
                <span class="title-sub-heading">{{ "accountRegistration.title_sub_heading" | cxTranslate }}</span>
                <div class="col-xs-12 col-sm-8 col-md-10 p0">
                    <form [formGroup]="contactsForm" id="contactsAddressForm" (ngSubmit)="createAccount()">
                        <div id="registerBilling">
                            <div formGroupName="primaryData">
                                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                                    <label for="primaryFirstName" class="Fields-label">{{
                    "accountRegistration.contactsInformation.firstName_label" | cxTranslate }}
                  </label>
                                    <input id="firstName" name="firstName" data-valid="valid_facility" maxlength="40" aria-labelledby="primaryData.firstName tooltipFacilityName" type="text" class="Fields-input" formControlName="firstName" data-di-id="#primaryData.firstName" mdgTextFilter
                                    />

                                    <span *ngIf="
                  !!contactsForm.get('primaryData.firstName').value &&
                  !contactsForm.get('primaryData.firstName').valid &&
                  contactsForm.get('primaryData.firstName').touched
                " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                                    <span *ngIf="
                  contactsForm.get('primaryData.firstName').errors?.required &&
                  !contactsForm.get('primaryData.firstName').valid &&
                  contactsForm.get('primaryData.firstName').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>

                                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                                    <label for="primaryLastName" class="Fields-label">{{
                    "accountRegistration.contactsInformation.lastName_label" | cxTranslate }} </label>
                                    <input id="lastName" name="lastName" data-valid="valid_facility" maxlength="40" aria-labelledby="billingAddressForm.facilityName tooltipFacilityName" type="text" class="Fields-input" formControlName="lastName" data-di-id="#billingAddressForm.facilityName"
                                        mdgTextFilter />

                                    <span *ngIf="
                  !!contactsForm.get('primaryData.lastName').value &&
                  !contactsForm.get('primaryData.lastName').valid &&
                  contactsForm.get('primaryData.lastName').touched
                " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                                    <span *ngIf="
                  contactsForm.get('primaryData.lastName').errors?.required &&
                  !contactsForm.get('primaryData.lastName').valid &&
                  contactsForm.get('primaryData.lastName').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>

                                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                asses_dropdown
              ">
                                    <label for="primaryTitle" id="contactTitleLabel" class="Fields-label">{{
                    "accountRegistration.contactsInformation.title_label" | cxTranslate }}</label>
                                    <div class="">
                                        <div class="">
                                            <ng-select name="title" [items]="contactTitle" [searchable]="false" [clearable]="false" bindLabel="name" bindValue="code" placeholder="Please select" formControlName="title" class="dropdown-credit"></ng-select>
                                        </div>
                                        <span *ngIf="
                    contactsForm.get('primaryData.title').errors?.required &&
                    !contactsForm.get('primaryData.title').valid &&
                    contactsForm.get('primaryData.title').touched
                  " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                      "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                                    </div>
                                </div>

                                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                asses_dropdown
              ">
                                    <label for="primaryRole" id="roleLabel" class="Fields-label">{{
                    "accountRegistration.contactsInformation.role_label" | cxTranslate }}</label>
                                    <div class="">
                                        <div class="">
                                            <ng-select name="role" [items]="contactRole" [searchable]="false" [clearable]="false" bindLabel="name" bindValue="code" placeholder="Please select" formControlName="role" class="dropdown-credit"></ng-select>
                                        </div>
                                        <span *ngIf="
                    contactsForm.get('primaryData.role').errors?.required &&
                    !contactsForm.get('primaryData.role').valid &&
                    contactsForm.get('primaryData.role').touched
                  " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                      "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                                    </div>
                                </div>


                                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                                    <label for="stateLicense" class="Fields-label">{{
                    "accountRegistration.contactsInformation.stateLicense" | cxTranslate }}

                  </label>
                                    <input id="stateLicense" name="statelicense" data-valid="valid_facility" aria-labelledby="accountRegistration.contactsInformation.stateLicense" maxlength="60" type="text" class="Fields-input" formControlName="stateLicense" data-di-id="" mdgTextFilter
                                        [readonly]="isFederal" autocomplete="off" />

                                    <span *ngIf="
                  !!contactsForm.get('primaryData.stateLicense').value &&
                  !contactsForm.get('primaryData.stateLicense').valid &&
                  contactsForm.get('primaryData.stateLicense').touched
                " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                                    <span *ngIf="
                  contactsForm.get('primaryData.stateLicense').errors?.required &&
                  !contactsForm.get('primaryData.stateLicense').valid &&
                  contactsForm.get('primaryData.stateLicense').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>

                                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                                    <label for="stateLicense" class="Fields-label">{{
                    "accountRegistration.contactsInformation.Expiration" | cxTranslate }}

                  </label>

                                    <input *ngIf="!isFederal" type="text" id="datepicker" name="datepicker" class="form-control Fields-input" placeholder="mm/dd/yyyy" formControlName="datepicker" bsDatepicker #dp="bsDatepicker" (focus)="dp.show()" [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY' }"
                                        [appMobMask]="'date'" (keypress)="onlyNumber($event)" (bsValueChange)="dateValidation($event)" maxlength="10" autocomplete="off" />

                                    <input *ngIf="isFederal" type="text" id="datepicker" name="datepicker" class="form-control Fields-input" formControlName="datepicker" readonly maxlength="10" autocomplete="off" />


                                    <span *ngIf="prevDateForExpiration && !contactsForm.get('primaryData.datepicker').errors?.required" class="errorMessage">Expiration date can't be smaller than current date</span>

                                    <span *ngIf="!prevDateForExpiration &&
              !!contactsForm.get('primaryData.datepicker').value &&
              !contactsForm.get('primaryData.datepicker').valid &&
              contactsForm.get('primaryData.datepicker').touched
            " class="errorMessage">{{ "accountRegistration.invalid_DATEFORMAT" | cxTranslate }}</span>
                                    <span *ngIf="
              contactsForm.get('primaryData.datepicker').errors?.required &&
              !contactsForm.get('primaryData.datepicker').valid &&
              contactsForm.get('primaryData.datepicker').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>

                                </div>


                                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container doubleLineContainer toggle-group">
                                    <label for="hin" class="Fields-label">{{
                    "accountRegistration.contactsInformation.hin" | cxTranslate }} </label>
                                    <input id="hin" name="hin" data-valid="valid_facility" aria-labelledby="accountRegistration.contactsInformation.hin" (keyup)="validateHIN($event)" maxlength="9" type="text" class="Fields-input" onkeypress="return /[0-9a-zA-Z]/i.test(event.key)" formControlName="hin"
                                        data-di-id="" mdgTextFilter/>
                                    <span style="position: relative;" *ngIf="deaValueValidationforHIN=='notValid'" class="defaultMessage" role="alert" aria-live="assertive">{{
                    "accountRegistration.invalid_dataformat" |
                    cxTranslate }}
                  </span>
                                    <span style="position: relative;" *ngIf="contactsForm.get('primaryData.hin').errors?.required &&
                                                                            !contactsForm.get('primaryData.hin').valid &&
                                        contactsForm.get('primaryData.hin').touched" class="defaultMessage" role="alert" aria-live="assertive">{{
                    "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>

                                    <div class="col-md-12 mt-1">
                                        <input type="checkbox" class="form-check-input m-0" id="hinCheckbox" (change)="toggleGroup($event)" />
                                        <label class="Fields-label-new d-inline align-middle" for="hinCheckbox">
                  {{ "accountRegistration.contactsInformation.hinCheckbox" | cxTranslate }} </label>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container doubleLineContainer toggle-group">
                                    <section class="Fields-container d-flex flex-row" style="gap:20px">
                                        <div class="formElementContainer d-flex flex-column mt-1" style="flex: 1 1 50%;">
                                            <label for="deaf1" class="Fields-label">{{
                    "accountRegistration.contactsInformation.deaF1" | cxTranslate }} </label>
                                            <input id="deaf1" name="deaf1" data-valid="valid_facility" maxlength="40" style="width: 100%;" aria-labelledby="accountRegistration.contactsInformation.deaF1" type="text" class="Fields-input" formControlName="deaName" data-di-id="" mdgTextFilter />
                                            <span style="position: relative;" *ngIf="contactsForm.get('primaryData.deaName').errors?.required &&
                        !contactsForm.get('primaryData.deaName').valid &&
                        contactsForm.get('primaryData.deaName').touched" class="defaultMessage" role="alert" aria-live="assertive">{{
                      "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>

                                        </div>

                                        <div class="formElementContainer d-flex flex-column mt-1" style="flex: 1 1 50%;">
                                            <label for="deaf2" class="Fields-label">{{
                  "accountRegistration.contactsInformation.deaF2" | cxTranslate }} </label>
                                            <input id="deaf2" name="deaf2" data-valid="valid_facility" aria-labelledby="accountRegistration.contactsInformation.deaF2" placeholder="XXXXXXXXXXXX" type="text" class="Fields-input" formControlName="dea" maxlength="9" oninput="this.value = this.value.toUpperCase()"
                                                (keyup)="validatepattrn($event)" data-di-id="" />

                                            <span *ngIf="deaValueValidation=='notValid'" class="defaultMessage" style="position: relative;" role="alert" aria-live="assertive">{{ "accountRegistration.invalid_dataformat" | cxTranslate }}
                    </span>
                                        </div>
                                    </section>

                                    <div class="col-md-12 mt-1">
                                        <input type="checkbox" class="form-check-input m-0" id="deaCheckbox" (change)="toggleGroup($event)" />
                                        <label class="Fields-label-new d-inline align-middle" for="deaCheckbox">
              {{ "accountRegistration.contactsInformation.deaCheckbox" | cxTranslate }} </label>
                                    </div>

                                </div>

                                <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                                    <label for="email" class="Fields-label">{{
                    "accountRegistration.contactsInformation.email.label" | cxTranslate }} </label>
                                    <input id="email" name="email" data-valid="valid_facility" data-charsfilter="email" aria-labelledby="accountRegistration.contactsInformation.email" type="text" class="Fields-input" formControlName="email" data-di-id="" mdgTextFilter />

                                    <span *ngIf="
              !!contactsForm.get('primaryData.email').value &&
              !contactsForm.get('primaryData.email').valid &&
              contactsForm.get('primaryData.email').touched
            " class="errorMessage">{{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                                    <span *ngIf="
              contactsForm.get('primaryData.email').errors?.required &&
              !contactsForm.get('primaryData.email').valid &&
              contactsForm.get('primaryData.email').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>

                                <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                                    <label for="confirmemail" class="Fields-label">{{
                    "accountRegistration.contactsInformation.confirm_email.label" | cxTranslate }} </label>
                                    <input id="confirmEmail" name="confirmemail" data-valid="valid_facility" data-charsfilter="email" aria-labelledby="accountRegistration.contactsInformation.confirmemail" type="text" class="Fields-input" formControlName="confirmEmail" data-di-id="" mdgTextFilter
                                    />

                                    <span *ngIf="
                !!contactsForm.get('primaryData.confirmEmail').value &&
                !contactsForm.get('primaryData.confirmEmail').invalid &&
                contactsForm.get('primaryData.confirmEmail').value !==
                contactsForm.get('primaryData.email').value
              " class="errorMessage">{{
                    "accountRegistration.form.confirm_email.email_not_match"
                    | cxTranslate
                    }}</span>


                                    <span *ngIf="
              !!contactsForm.get('primaryData.confirmEmail').value &&
              !contactsForm.get('primaryData.confirmEmail').valid &&
              contactsForm.get('primaryData.confirmEmail').touched
            " class="errorMessage">{{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                                    <span *ngIf="
              contactsForm.get('primaryData.confirmEmail').errors?.required &&
              !contactsForm.get('primaryData.confirmEmail').valid &&
              contactsForm.get('primaryData.confirmEmail').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>

                                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container small-device">
                                    <div class="phone-extension">
                                        <div class="phone-container">
                                            <label for="phone" class="Fields-label">{{
                        "accountRegistration.contactsInformation.phone.label" | cxTranslate }}
                        <span>{{
                          "accountRegistration.optional_tag" | cxTranslate
                          }}</span>
                      </label>
                                            <input id="phone" name="phone" data-valid="valid_phone" placeholder="123-456-7890" maxlength="12" appPhoneMask type="text" class="Fields-input phone-no-mask" formControlName="phone" autocomplete="off" data-di-id="#formPhone" />

                                            <span *ngIf="
                  !!contactsForm.get('primaryData.phone').value &&
                  !contactsForm.get('primaryData.phone').valid &&
                  contactsForm.get('primaryData.phone').touched
                " class="errorMessage">{{ "accountRegistration.form.phone.ph_validation_msg" | cxTranslate }}</span>
                                            <span *ngIf="
                  contactsForm.get('primaryData.phone').errors?.required &&
                  !contactsForm.get('primaryData.phone').valid &&
                  contactsForm.get('primaryData.phone').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                        cxTranslate }}
                      </span>
                                        </div>


                                        <div class="phone-container doubleLineContainer">
                                            <label for="extension" class="Fields-label">{{
                        "accountRegistration.contactsInformation.extension.label" | cxTranslate }}
                        <span>{{
                          "accountRegistration.optional_tag" | cxTranslate
                          }}</span>
                      </label>
                                            <input id="extension" name="extension" data-valid="valid_facility" aria-labelledby="accountRegistration.contactsInformation.extension" type="text" class="Fields-input" formControlName="extension" placeholder="-" data-di-id="" />
                                        </div>


                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                                    <!-- re-captcha
                  *ngIf="recaptchaEnabled"
                  [siteKey]="siteKey"
                  formControlName="captcha" 
                  (resolved)="showCaptchaErrorMsg = false"
                  ></re-captcha -->
                                    <div id="recaptcha-container"></div>

                                    <br/>

                                    <span *ngIf="showCaptchaErrorMsg" class="defaultMessage" role="alert" aria-live="assertive">{{
                        "accountRegistration.requiredMsg" |
                        cxTranslate }}
                  </span>
                                </div>

                                <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          " style="display:none;">
                                    <label for="shippingAddressForm.shippingAddress" id="shippingAddress" class="Fields-label-new">{{
                    "accountRegistration.primary_office_contact.is_office_contact"
                    | cxTranslate
                    }}</label>
                                    <div class="custom-control custom-radio radio_grp label-location">
                                        <input type="radio" id="shippingAddressForm.shippingAddress1" class="" [value]="true" checked (click)="replicateForm('Y')" />
                                        <label class="ctClassForLabel secloct" for="shippingAddressForm.shippingAddress1">
                      Yes
                    </label>
                                    </div>
                                    <div class="custom-control custom-radio radio_grp label-location">
                                        <input type="radio" id="shippingAddressForm.shippingAddress2" class="" [value]="false" (click)="replicateForm('N')" />
                                        <label class="ctClassForLabel" for="shippingAddressForm.shippingAddress2">
                      No
                    </label>
                                    </div>
                                </div>


                                <div *ngIf="!isPrimaryFlag">


                                    <div class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              doubleLineContainer
            ">


                                        <ng-template #errorPopContent>{{ "accountRegistration.special_validation_msg_popover" | cxTranslate }}
                                        </ng-template>

                                        <label for="facilityName" class="Fields-label icon-label">{{
                      "accountRegistration.contactsInformation.firstName_label"
                      |
                      cxTranslate }}
                    </label>

                                        <input id="firstName_repeat" name="firstName_repeat" required data-valid="valid_facility" aria-labelledby="primaryData.firstName_repeat tooltipFacilityName" type="text" maxlength="40" class="Fields-input" formControlName="firstName_repeat" data-di-id="#primaryData.firstName_repeat"
                                            mdgTextFilter />

                                        <span *ngIf="
                !!contactsForm.get('primaryData.firstName_repeat').value &&
                !contactsForm.get('primaryData.firstName_repeat').valid &&
                contactsForm.get('primaryData.firstName_repeat').touched
              " class="errorMessage">{{
                      "accountRegistration.alpha_numeric_msg" | cxTranslate
                      }}</span>
                                        <span *ngIf="
                contactsForm.get('primaryData.firstName_repeat').errors
                  ?.required &&
                !contactsForm.get('primaryData.firstName_repeat').valid &&
                contactsForm.get('primaryData.firstName_repeat').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                                    </div>

                                    <div class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              doubleLineContainer
            ">


                                        <ng-template #errorPopContent>{{ "accountRegistration.special_validation_msg_popover" | cxTranslate }}
                                        </ng-template>

                                        <label for="facilityName" class="Fields-label icon-label">{{
                      "accountRegistration.contactsInformation.lastName_label"
                      |
                      cxTranslate }}
                    </label>
                                        <input id="lastname_repeat" name="lastname_repeat" required data-valid="valid_facility" maxlength="40" aria-labelledby="primaryData.lastname_repeat tooltipFacilityName" type="text" class="Fields-input" formControlName="lastname_repeat" data-di-id="#primaryData.lastname_repeat"
                                            mdgTextFilter />

                                        <span *ngIf="
                !!contactsForm.get('primaryData.lastname_repeat').value &&
                !contactsForm.get('primaryData.lastname_repeat').valid &&
                contactsForm.get('primaryData.lastname_repeat').touched
              " class="errorMessage">{{
                      "accountRegistration.alpha_numeric_msg" | cxTranslate
                      }}</span>
                                        <span *ngIf="
                contactsForm.get('primaryData.lastname_repeat').errors
                  ?.required &&
                !contactsForm.get('primaryData.lastname_repeat').valid &&
                contactsForm.get('primaryData.lastname_repeat').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                                    </div>


                                    <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                asses_dropdown
              ">
                                        <label for="primaryTitle" id="contactTitleLabel" class="Fields-label">{{
                      "accountRegistration.contactsInformation.title_label" | cxTranslate }}</label>
                                        <div class="">
                                            <div class="">
                                                <ng-select name="title_repeat" [items]="contactTitle" [searchable]="false" [clearable]="false" bindLabel="name" bindValue="code" placeholder="Please select" formControlName="title_repeat" class="dropdown-credit"></ng-select>
                                            </div>
                                            <span *ngIf="
                    contactsForm.get('primaryData.title_repeat').errors?.required &&
                    !contactsForm.get('primaryData.title_repeat').valid &&
                    contactsForm.get('primaryData.title_repeat').touched
                  " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                        "accountRegistration.requiredMsg" | cxTranslate }}
                      </span>
                                        </div>
                                    </div>


                                    <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            asses_dropdown
          ">
                                        <label for="primaryRole" id="roleLabel" class="Fields-label">{{
                      "accountRegistration.contactsInformation.role_label" | cxTranslate }}</label>
                                        <div class="">
                                            <div class="">
                                                <ng-select name="role_repeat" [items]="contactRole" [searchable]="false" [clearable]="false" bindLabel="name" bindValue="code" placeholder="Please select" formControlName="role_repeat" class="dropdown-credit"></ng-select>
                                            </div>
                                            <span *ngIf="
                contactsForm.get('primaryData.role_repeat').errors?.required &&
                !contactsForm.get('primaryData.role_repeat').valid &&
                contactsForm.get('primaryData.role_repeat').touched
              " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                        "accountRegistration.requiredMsg" | cxTranslate }}
                      </span>
                                        </div>
                                    </div>


                                    <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                                        <label for="stateLicense" class="Fields-label">{{
                      "accountRegistration.contactsInformation.stateLicense" | cxTranslate }}
                      <span>{{
                        "accountRegistration.optional_tag" | cxTranslate
                        }}</span>
                    </label>
                                        <input id="stateLicense_repeat" name="statelicense_repeat" data-valid="valid_facility" aria-labelledby="accountRegistration.contactsInformation.stateLicense" type="text" class="Fields-input" formControlName="stateLicense_repeat" data-di-id="" mdgTextFilter
                                        />

                                        <span *ngIf="
              !!contactsForm.get('primaryData.stateLicense_repeat').value &&
              !contactsForm.get('primaryData.stateLicense_repeat').valid &&
              contactsForm.get('primaryData.stateLicense_repeat').touched
            " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                                        <span *ngIf="
              contactsForm.get('primaryData.stateLicense_repeat').errors?.required &&
              !contactsForm.get('primaryData.stateLicense_repeat').valid &&
              contactsForm.get('primaryData.stateLicense_repeat').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                                    </div>

                                    <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                                        <label for="stateLicense" class="Fields-label">{{
                      "accountRegistration.contactsInformation.Expiration" | cxTranslate }}
                      <span>{{
                        "accountRegistration.optional_tag" | cxTranslate
                        }}</span>
                    </label>

                                        <input class="Fields-input" id="datepicker_repeat" name="datepicker_repeat" placeholder="mm/dd/yyyy" [(ngModel)]="model2" (click)="d.toggle()" ngbDatepicker #d="ngbDatepicker" formControlName="datepicker_repeat" />
                                        <span *ngIf="
          !!contactsForm.get('primaryData.datepicker_repeat').value &&
          !contactsForm.get('primaryData.datepicker_repeat').valid &&
          contactsForm.get('primaryData.datepicker_repeat').touched
        " class="errorMessage">{{ "accountRegistration.invalid_DATEFORMAT" | cxTranslate }}</span>
                                        <span *ngIf="
          contactsForm.get('primaryData.datepicker_repeat').errors?.required &&
          !contactsForm.get('primaryData.datepicker_repeat').valid &&
          contactsForm.get('primaryData.datepicker_repeat').touched
        " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>

                                    </div>


                                    <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container doubleLineContainer toggle-group">
                                        <label for="hin" class="Fields-label">{{
                      "accountRegistration.contactsInformation.hin" | cxTranslate }} </label>
                                        <input id="hin_repeat" name="hin_repeat" data-valid="valid_facility" aria-labelledby="accountRegistration.contactsInformation.hin" type="text" class="Fields-input" formControlName="hin_repeat" data-di-id="" mdgTextFilter />

                                        <div class="col-md-12 mt-1">
                                            <input type="checkbox" class="form-check-input m-0" id="hinCheckbox" (change)="toggleGroup($event)" formControlName="hinCheckbox" />
                                            <label class="Fields-label-new d-inline align-middle" for="hinCheckbox">
                        {{ "accountRegistration.contactsInformation.hinCheckbox" | cxTranslate }} </label>
                                        </div>

                                    </div>

                                    <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container doubleLineContainer toggle-group">
                                        <section class="Fields-container d-flex flex-row" style="gap:20px">
                                            <div class="formElementContainer d-flex flex-column mt-1" style="flex: 1 1 50%;">

                                                <label for="deaf1" class="Fields-label">{{
                      "accountRegistration.contactsInformation.deaF1" | cxTranslate }} </label>
                                                <input id="deaf1_repeat" name="deaf1_repeat" data-valid="valid_facility" maxlength="40" aria-labelledby="accountRegistration.contactsInformation.deaF1" type="text" class="Fields-input" formControlName="deaName_repeat" data-di-id="" mdgTextFilter />
                                                <span *ngIf="contactsForm.get('primaryData.deaf1_repeat').errors?.required &&
                          !contactsForm.get('primaryData.deaf1_repeat').valid &&
                          contactsForm.get('primaryData.deaf1_repeat').touched" class="defaultMessage" role="alert" aria-live="assertive">{{
                        "accountRegistration.requiredMsg" |
                        cxTranslate }}
                      </span>
                                            </div>
                                            <div class="formElementContainer d-flex flex-column mt-1" style="flex: 1 1 50%;">

                                                <label for="deaf2" class="Fields-label">{{
                      "accountRegistration.contactsInformation.deaF2" | cxTranslate }} </label>
                                                <input id="dea_repeat" name="dea_repeat" data-valid="valid_facility" style="width: 100%;" aria-labelledby="accountRegistration.contactsInformation.deaF2" placeholder="XXXXXXXXXXXX" type="text" class="Fields-input" formControlName="dea_repeat" data-di-id=""
                                                />

                                            </div>
                                        </section>
                                        <div>
                                            <input type="checkbox" class="form-check-input mt-0" id="deaCheckbox" (change)="toggleGroup($event)" formControlName="deaCheckbox" />
                                            <label class="Fields-label-new" for="deaCheckbox">
                {{ "accountRegistration.contactsInformation.deaCheckbox" | cxTranslate }} </label>
                                        </div>
                                    </div>

                                    <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
        doubleLineContainer
      ">
                                        <label for="email" class="Fields-label">{{
                      "accountRegistration.contactsInformation.email.label" | cxTranslate }} </label>
                                        <input id="email_repeat" name="email_repeat" data-valid="valid_facility" aria-labelledby="accountRegistration.contactsInformation.email" type="text" class="Fields-input" formControlName="email_repeat" data-di-id="" mdgTextFilter />

                                        <span *ngIf="
          !!contactsForm.get('primaryData.email_repeat').value &&
          !contactsForm.get('primaryData.email_repeat').valid &&
          contactsForm.get('primaryData.email_repeat').touched
        " class="errorMessage">{{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                                        <span *ngIf="
          contactsForm.get('primaryData.email_repeat').errors?.required &&
          !contactsForm.get('primaryData.email_repeat').valid &&
          contactsForm.get('primaryData.email_repeat').touched
        " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                                    </div>

                                    <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
        doubleLineContainer
      ">
                                        <label for="confirmemail" class="Fields-label">{{
                      "accountRegistration.contactsInformation.confirm_email.label" | cxTranslate }} </label>
                                        <input id="confirmEmail_repeat" name="confirmemail_repeat" data-valid="valid_facility" aria-labelledby="accountRegistration.contactsInformation.confirmemail" type="text" class="Fields-input" formControlName="confirmEmail_repeat" data-di-id="" mdgTextFilter
                                        />

                                        <span *ngIf="
            !!contactsForm.get('primaryData.confirmEmail_repeat').value &&
            !contactsForm.get('primaryData.confirmEmail_repeat').invalid &&
            contactsForm.get('primaryData.confirmEmail_repeat').value !==
            contactsForm.get('primaryData.email_repeat').value
          " class="errorMessage">{{
                      "accountRegistration.form.confirm_email.email_not_match"
                      | cxTranslate
                      }}</span>


                                        <span *ngIf="
          !!contactsForm.get('primaryData.confirmEmail_repeat').value &&
          !contactsForm.get('primaryData.confirmEmail_repeat').valid &&
          contactsForm.get('primaryData.confirmEmail_repeat').touched
        " class="errorMessage">{{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                                        <span *ngIf="
          contactsForm.get('primaryData.confirmEmail_repeat').errors?.required &&
          !contactsForm.get('primaryData.confirmEmail_repeat').valid &&
          contactsForm.get('primaryData.confirmEmail_repeat').touched
        " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                                    </div>

                                </div>

                            </div>

                            <!-- Other New Section Ends -->
                            <hr class="Fields-container-line billingPage" />
                            <div class="invoice-btngrps">
                                <button type="button" (click)="back()" class="btn-secondary" data-di-id="di-id-7a6cb2cd-cb37948a">
                  {{ "accountRegistration.form.back_button" | cxTranslate }}
                </button>
                                <button type="submit" *ngIf="deaValueValidation=='Valid' && deaValueValidationforHIN=='Valid'" class="btn-primary" data-di-id="di-id-7a6cb2cd-cb37948a">
                  {{ "accountRegistration.form.submit_button" | cxTranslate }}
                </button>
                                <button type="submit" *ngIf="deaValueValidation=='notValid' || deaValueValidationforHIN=='notValid'" disabled class="btn-primary" data-di-id="di-id-7a6cb2cd-cb37948a">
                  {{ "accountRegistration.form.submit_button" | cxTranslate }}
                </button>
                            </div>
                        </div>
                    </form>
                </div>


            </div>
        </div>


    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 needCls needCls2 Notify-Msg" [innerHTML]="(finalNeedAss | async)?.content"></div>
</div>